import { render } from "./GeneralConditions.vue?vue&type=template&id=12c14d00"
import script from "./GeneralConditions.vue?vue&type=script&lang=js"
export * from "./GeneralConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__